import type { RuntimeConfig } from 'nuxt/schema';

import type { StrictFetchContext } from '#strict-fetch';

export const configToBaseUrlMapper = (context: StrictFetchContext, config: RuntimeConfig) => {
  const developmentBaseURLMapper = {
    prefix: new RegExp(/^(?!client\/)/),
    value: '/api/server/',
  };

  const serverBaseURLMapper = {
    prefix: new RegExp(/^(?!client\/)/),
    value: import.meta.server ? `${config.public.siteUrl}/api/` : '/api/',
  };

  const mapper = config.public.siteEnvironment === 'dev' ? developmentBaseURLMapper : serverBaseURLMapper;

  if (mapper.prefix.test(context.request.toString())) {
    context.request = context.request.toString().replace(mapper.prefix, '');
    if (!context.options.baseURL) context.options.baseURL = mapper.value;
  } else {
    if (!context.options.baseURL) context.options.baseURL = '/api/';
  }
};
